import * as React from 'react';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function FormFileUpload({
  label = 'Choose file',
  buttonLabel = 'Upload file',
  file,
  accept,
  onChange,
  ...props
}) {
  return (
    <div {...props}>
      {label ? (
        <Typography variant="body2" sx={{ mb: 1 }}>
          {label}
        </Typography>
      ) : null}
      <Button
        component="label"
        variant="outlined"
        startIcon={<UploadFileIcon />}
      >
        {buttonLabel}
        <VisuallyHiddenInput
          type="file"
          accept={accept}
          onChange={onChange}
        />
      </Button>
      {file ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          {file.name}
        </Typography>
      ) : null}
    </div>
  );
}
